import * as _linkify from 'linkifyjs';

export const linkify = _linkify;
